module.exports = __webpack_public_path__ + "img/Timeline_image_2010.4cd19b29.png";